import React from 'react';

interface IProps {
  size?: string;
}

const ArrowLeftIcon: React.FC<IProps> = ({ size = '22' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 22 22"
    fill="none"
    className={`h-[${size}px] w-[${size}px]`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.77315 5.43579L3.20898 11L8.77315 16.5641"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.7908 11H3.36328"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowLeftIcon;
